var $bca1931646cb2236$exports = {};
$bca1931646cb2236$exports = {
    "collapse": `\u{6298}\u{53E0}`,
    "expand": `\u{6269}\u{5C55}`
};


export {$bca1931646cb2236$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
